// extracted by mini-css-extract-plugin
module.exports = {"styledSwitch":"BaseSwitch_styledSwitch_1k7TG","isDisabled":"BaseSwitch_isDisabled_2On6Z"};